__turbopack_context__.v({
  "className": "noto_sans_devanagari_eb056fd4-module__B1xGSa__className",
});
